import { memo } from "react"

import { Column } from "@/atoms"
import { TooltipGraph } from "./TooltipGraph"

import styles from "./HeaderDeploymentsTab.module.scss"

import type { getSensorsCount } from "@/pages/DeploymentsPage/application/useFiltersDeployments.selector"

export const SensorUsageGraph = memo(
  function SensorUsageGraphComponent(props: {
    buckets?: ReturnType<typeof getSensorsCount>["buckets"]
  }) {
    const config = {
      autoFit: true,
      height: 100,
      legend: false as const,
      columnWidthRatio: 0.6,
      xAxis: {
        label: null,
        line: null,
        tickLine: null,
        grid: null
      },
      yAxis: {
        label: null,
        grid: null
      },
      seriesField: "type",
      color: () => "#69C0FF",
      columnStyle: () => ({ radius: [2, 2] })
    }

    return (
      <div className={styles.graphContainer}>
        <Column
          xField="bucketStart"
          yField="liveCount"
          data={props.buckets || []}
          tooltip={{
            customContent: (_, item) => {
              const { bucketStart, liveCount } = item?.[0]?.data || {}

              return (
                <TooltipGraph
                  count={liveCount}
                  label="Peak"
                  timestamp={bucketStart}
                />
              )
            }
          }}
          {...config}
        />
      </div>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.buckets === nextProps.buckets
  }
)
